import React from 'react';

import { Stack, Status } from '@gogame/components';

import {
  STATUS_LABELS,
  STATUS_COLORS,
} from 'scenes/Gallery/GalleryPage/constants';

export const getColor = (id) => STATUS_COLORS[id];

const StatusBadge = ({ id, children }) => {
  return (
    <Status color={getColor(id)}>
      <Stack spacing={1} direction={'row'} alignItems={'center'}>
        <Stack>{STATUS_LABELS[id]}</Stack>
        {children}
      </Stack>
    </Status>
  );
};

export default StatusBadge;
